import Stack from 'shell/components/Stack';
import Text from 'shell/components/Text';

const AssignmentValidationSummary = ({ items }) => (
    <Stack component={'ul'} spacing={1} sx={{ m: 0, pl: 3 }}>
        {items.map(({ key, label }) => (
            <Text component={'li'} key={key} sx={{ textAlign: 'left' }}>
                {label}
            </Text>
        ))}
    </Stack>
);

export default AssignmentValidationSummary;
